import SchoolCreatePage from "./schoolCreatePage"
export default SchoolCreatePage;